import { getShopSiteUrl } from '@/shared/shop-site'

/**
 * Where the Shop's product photos live. Originals sit in a private bucket;
 * the Shop proxies right-sized copies at `/api/public/img/<path>?w=&q=`, so a
 * storage URL is rewritten to that proxy rather than loaded directly.
 */
const SHOP_STORAGE_ORIGIN = 'https://finjtbcupndfgeoaihyv.supabase.co'
const PRODUCT_IMAGE_PATH = /\/storage\/v1\/(?:object|render\/image)\/(?:sign|public)\/product-images\/(.+)$/

function encodedPath(path: string): string | null {
  try {
    const decoded = decodeURIComponent(path).split('/').filter(Boolean)
    if (!decoded.length || decoded.some((part) => part === '.' || part === '..')) return null
    return decoded.map(encodeURIComponent).join('/')
  } catch {
    return null
  }
}

/**
 * A renderable `src` for a Shop product image, or `null` when the value is
 * not an http(s) URL we can place. Port of the Lovable landing's resolver.
 */
export function resolveShopImageUrl(
  input: string | null | undefined,
  width = 192,
  shopOrigin: string = getShopSiteUrl()
): string | null {
  const value = input?.trim()
  if (!value) return null
  try {
    decodeURIComponent(value)
    const url = new URL(value, shopOrigin)
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null
    const match = url.pathname.match(PRODUCT_IMAGE_PATH)
    if (match && (url.origin === SHOP_STORAGE_ORIGIN || url.origin === shopOrigin)) {
      const path = encodedPath(match[1])
      return path ? `${shopOrigin}/api/public/img/${path}?w=${width}&q=65` : null
    }
    if (url.origin === shopOrigin) return url.toString()
    if (/^https?:\/\//i.test(value)) return url.toString()
    return new URL(url.pathname.replace(/^\/+/, '/'), shopOrigin).toString()
  } catch {
    return null
  }
}
